<mat-form-field [formGroup]="form" class="size-sm w-full" floatLabel="auto">
  <mat-label>{{ label ? (label | translate) : "global.filter.dateRangeLabel" | translate }}</mat-label>
  <mat-date-range-input (focus)="picker.open()" [rangePicker]="picker" formGroupName="dateRange" [min]="minDate"
                        [max]="maxDate">
    <input [placeholder]="'global.filter.dateFrom' | translate"
           formControlName="dateFrom"
           matStartDate
           readonly>
    <input [placeholder]="'global.filter.dateTo' | translate"
           formControlName="dateTo"
           matEndDate
           readonly>
  </mat-date-range-input>
  <mat-icon (click)="clear($event)"
            aria-label="Clear date range"
            *ngIf="showClearButton && (form.get('dateRange.dateFrom')?.value || form.get('dateRange.dateTo')?.value)"
            class="p-0 cursor-pointer"
            matSuffix>
    cancel
  </mat-icon>
  <mat-datepicker-toggle [for]="picker" matIconSuffix />
  <mat-date-range-picker #picker />
</mat-form-field>
